import { ApiResponse } from "@apis/api.ts";

type GetSignedUrlFunc<TParams> = (params: TParams) => Promise<ApiResponse<string>>;
type FetchResourceFunc<TParams> = (
  params: TParams,
  signedParams: URLSearchParams,
) => Promise<ApiResponse<unknown>>;

/**
 * Generic utility to fetch resource via signed URL.
 */
export async function fetchWithSignedUrl<TSignedUrlParams, TResourceParams>(
  getSignedUrl: GetSignedUrlFunc<TSignedUrlParams>,
  fetchResource: FetchResourceFunc<TResourceParams>,
  signedUrlParams: TSignedUrlParams,
  resourceParams: TResourceParams,
): Promise<ApiResponse<unknown>> {
  // Step 1: get signed URL
  const signedUrlResponse = await getSignedUrl(signedUrlParams);
  if (!signedUrlResponse?.data) {
    throw new Error("Failed to get signed URL");
  }

  // Step 2: parse signed URL
  const url = new URL(signedUrlResponse.data);
  const signedParams = new URLSearchParams(url.search);

  // Step 3: call actual resource fetcher
  return fetchResource(resourceParams, signedParams);
}
